import { getGlobalFilter, getProjectZoneId } from '../reducers/analyticsApp';
import { toFilter } from './filterConverter';
import { transformStep } from '../actions/common';
import { fromFunnelResult } from './compoundConverter';

export const buildDashboardFunnelQuery = (state, unit) => {
  const timezone = getProjectZoneId(state);
  const globalFilter = toFilter(getGlobalFilter(state));
  const selectedFunnel = unit.compose.funnels.funnel;
  const steps = selectedFunnel.steps.map(transformStep);
  const { conversionInterval } = unit.compose.funnels.options;

  return {
    timezone,
    globalFilter,
    steps,
    filter: selectedFunnel.dateRange ? { ...selectedFunnel.dateRange } : null,
    conversionInterval,
  };
};

export const fromFunnelDashbordResponse = (response, query, unit) => ({
  result: fromFunnelResult(response, query, unit.compose.funnels.funnel, unit),
  manualEnabled: true,
  unit,
});
